import React from 'react';

type Props = { 
  onClick: () => void; 
  title?: string;
  className?: string;
};

export default function RollbackButton({ 
  onClick, 
  title = 'Change answer',
  className = "p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={className}
      aria-label="Undo answer"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
      </svg>
    </button>
  );
}
